import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var ContainerNodeEvent = /** @class */ (function (_super) {
    __extends(ContainerNodeEvent, _super);
    function ContainerNodeEvent(type) {
        return _super.call(this, type) || this;
    }
    /**
     * Clones the event.
     * @return An exact duplicate of the current object.
     */
    ContainerNodeEvent.prototype.clone = function () {
        return new ContainerNodeEvent(this.type);
    };
    /**
     *
     */
    ContainerNodeEvent.INVALIDATE_MATRIX3D = 'invalidateMatrix3D';
    ContainerNodeEvent.INVALIDATE_COLOR_TRANSFORM = 'invalidateColorTransform';
    return ContainerNodeEvent;
}(EventBase));
export { ContainerNodeEvent };
